module.exports = __webpack_public_path__ + "static/benefits_two-def2b4f840ea9cfe0c09b17ea81b5fee.png";